<div class="flex-row padding-30">
  <div class="flex-1"></div>

  <div class="flex-3 border pt-5 pb-5">
    <form [formGroup]="employeeForm" (ngSubmit)="onSubmit()" class="flex-column justify-content-center align-items-center">
      <h1 class="margin-bottom-25 center-text large-text">{{formAction}} an Employee</h1>

      <mat-form-field class="form-width" appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput type="text" formControlName="firstName" />
        @if (formControls.firstName.hasError('required')) {
          <mat-error>First Name is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="form-width" appearance="outline">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" formControlName="lastName" />
        @if (formControls.firstName.hasError('required')) {
          <mat-error>Last Name is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="form-width" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="emailAddress" />
        @if (formControls.emailAddress.hasError('email') || formControls.emailAddress.hasError('pattern')) {
          <mat-error>
            Please enter a valid email address
          </mat-error>
        }
        @if (formControls.emailAddress.hasError('required')) {
          <mat-error>
            Email is required
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-width" appearance="outline">
        <mat-label>Employee Role</mat-label>
        <mat-select [(ngModel)]="selectedEmployeeRole" [ngModelOptions]="{standalone: true}">
          @for (employeeRole of employeeRoles | keyvalue; track employeeRole) {
            <mat-option [value]="employeeRole.key">
              {{employeeRole.value}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="form-width" appearance="outline">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password" minlength="8" />
        @if (formControls.password.hasError('pattern') || formControls.password.hasError('minlength')) {
          <mat-error>Password does not meet requirements</mat-error>
        }
      </mat-form-field>

      <ul class="border password-param">
        <li>Minimum eight characters</li>
        <li>At least one upper case letter</li>
        <li>At least one lower case letter</li>
        <li>At least one digit</li>
        <li>At least one special of the following special character<br/>#?!&#64;$^&*-</li>
      </ul>



        <button mat-flat-button [disabled]="loading || employeeForm.invalid" class="border-2 shade w-50">
          @if (loading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          Save
        </button>
    </form>
  </div>

  <div class="flex-1">
    <button mat-icon-button (click)="goBack()" class="float-right flex-row" aria-label="Return to employees screen">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>
</div>